import { render, staticRenderFns } from "./RicercaOperai.vue?vue&type=template&id=d5fe06c6&scoped=true&"
import script from "./RicercaOperai.vue?vue&type=script&lang=js&"
export * from "./RicercaOperai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fe06c6",
  null
  
)

export default component.exports